<template>
	<div id="creatproject_takpage" class="clearfix notosans darkblue">
        <div class="col-12">
            <div class="clearfix highlights col-7 mx-auto mt4">
                <div class="col-12 px0 flex justify-between items-center my4">
                    <p class="h3 bold center col-12 p0">Gennemført!</p>
                </div>
                <div class="col-12 px2 flex flex-column justify-center mb3">
                    <p class="col-12 mt2 mb3 center">Dit projekt er tilføjet</p> 
                    <div class="flex flex-column items-center">
                            <p class="h6 small mediumgrey my2">Projekt Url:</p>
                            <a class="no-underline" target="_blank" :href="projecturl.replace('håndværker','haandvaerker').replace('xn--hndvrker-9zan','haandvaerker')">{{projecturl.replace('håndværker','haandvaerker').replace('xn--hndvrker-9zan','haandvaerker')}}</a>
                    </div>
                </div>
	          </div>  
            <div class="col-7 mx-auto m0 p0 flex flex-column my2">
              <button class="h6 col-12 sharefb-button flex justify-center mb2 py2" @click="facebokUrl(projecturl.replace('håndværker','haandvaerker').replace('xn--hndvrker-9zan','haandvaerker'))">
                <span class="p0 m0 pr1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="7.861" height="14.047" viewBox="0 0 11.861 22.047">
                    <path id="Icon_zocial-facebook" data-name="Icon zocial-facebook" d="M13.257,11.839V7.629h3.4V5.512a5.541,5.541,0,0,1,1.487-3.9A4.732,4.732,0,0,1,21.745,0h3.373V4.211H21.745a.743.743,0,0,0-.595.364,1.477,1.477,0,0,0-.265.893V7.628h4.232v4.21H20.885V22.047H16.652V11.839Z" transform="translate(-13.257)" fill="#fff"/>
                  </svg>
                </span>
                <p class="p0 m0">Del dit projekt pa Facebook</p>
              </button>
              <button v-clipboard:copy="projecturl" v-clipboard:success="successCopy" v-clipboard:error="onErrorCopy" class="h6 col-12 action-button flex justify-center py2">
                Kopier url
              </button>
            </div>
        </div>
        <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
    </div>
</template>
<script>
import Simplert from 'vue2-simplert'
export default {
  name: 'creatproject_takpage',
  components: {
    Simplert
  },
  watch: {
  },
  created () {
    this.projecturl = this.$route.query.projecturl
  },
  data () {
    return {
      haaId: '',
      salesPerson: '',
      projecturl: ''
    }
  },
  mounted () {
  },
  methods: {
    facebokUrl (url) {
      window.open('https://www.facebook.com/sharer/sharer.php?u=' + url, '_blank')
    },
    successCopy () {
      let obj = {
        title: 'Url er nu kopieret.',
        message: '',
        type: 'success',
        customCloseBtnText: 'Luk'
      }
      this.$refs.simplert.openSimplert(obj)
    },
    onErrorCopy () {
      alert('Kan ikke kopiere')
      let obj = {
        title: 'Kan ikke kopiere',
        message: '',
        type: 'Error',
        customCloseBtnText: 'Luk'
      }
      this.$refs.simplert.openSimplert(obj)
    }
  }
}
</script>
<style>
#creatproject_takpage .sharefb-button {
  background: #1F78F2 0% 0% no-repeat padding-box;
  border-radius: 1px;
  color: #fff;
  border-color: #1F78F2;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// CreateProject_Tak.vue?2ea4ed40